import { render } from "./view-offer.vue?vue&type=template&id=9bd23c0e&scoped=true&lang=html"
import script from "./view-offer.vue?vue&type=script&lang=js"
export * from "./view-offer.vue?vue&type=script&lang=js"

import "./view-offer.vue?vue&type=style&index=0&id=9bd23c0e&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd23c0e"]])

export default __exports__